import { conditionValidator } from "./conditionValidator";

export const initScriptRun = (_initScript, _variable) =>
{


  _initScript.script.forEach(s => {



    let isValid = s.condition.every(c => {

      let formattedCondition = {
        type: "if",
        valueLeft: {
          type: "globalVariable",
          variable: c.variable,
          variableTypeCode: c.variableType,
        },
        valueRight: {
          type: "literal",
          data: c.value
        },
        operator: c.operator
      }

      return conditionValidator(formattedCondition, [], _variable);


    });


    if (isValid)
    {

      s.action.forEach(a =>
      {


        switch (a.operator) {
          case "assign":

            let variableIndex = _variable.findIndex(v => v._id == a.variable);

            if (variableIndex == -1) break;

            _variable[variableIndex].data = a.value;
            
            break;
        
          default:
            break;
        }

      });


    }



   
  });

  


  return _variable;

}